export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.errorHandler = (err) => {
    clearError()
    nuxtApp.$notificationStore.set({
      title: 'Vorgang fehlgeschlagen',
      text: 'Es ist ein unerwarteter Fehler aufgetreten. Ein Administrator wurde benachrichtigt und wir arbeiten an der Behebung. Bitte versuchen Sie es später erneut.',
      type: 'error',
    })
    if (nuxtApp.$config.public.environment === 'production') {
      console.log('vueApp:errorHandler', err)
    } else {
      throw err
    }
  }
  nuxtApp.hook('vue:error', (err) => {
    clearError()
    nuxtApp.$notificationStore.set({
      title: 'Vorgang fehlgeschlagen',
      text: 'Es ist ein unerwarteter Fehler aufgetreten. Ein Administrator wurde benachrichtigt und wir arbeiten an der Behebung. Bitte versuchen Sie es später erneut.',
      type: 'error',
    })
    if (nuxtApp.$config.public.environment === 'production') {
      console.log('vue:error', err)
    } else {
      throw err
    }
  })
  nuxtApp.hook('app:error', (err) => {
    clearError()
    nuxtApp.$notificationStore.set({
      title: 'Vorgang fehlgeschlagen',
      text: 'Es ist ein unerwarteter Fehler aufgetreten. Ein Administrator wurde benachrichtigt und wir arbeiten an der Behebung. Bitte versuchen Sie es später erneut.',
      type: 'error',
    })
    if (nuxtApp.$config.public.environment === 'production') {
      console.log('app:error', err)
    } else {
      throw err
    }
  })
})
